import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import parentStyles from '../../LoginContainer/styles.module.scss'
import Button from 'srcReact/components/common2/Button'
import { useTranslation } from 'react-i18next'
import { isEmpty } from 'srcReact/helpers/validator'
import PasswordTextBox from 'srcReact/components/common2/PasswordTextBox'
import { useDispatch } from 'react-redux'
import { loginActions } from 'srcReact/LoginPage/actions'
import Spinner from 'srcReact/components/common2/Spinner'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import { isPasswordComplex } from 'srcReact/helpers/utils'

function ConfirmPassword({
  currentState,
  setCurrentState,
  setCurrentStep,
  error,
  loading,
  loginSuccess,
  workplaceInvitations
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [passwordRef, setPasswordRef] = useState(null)
  const [confirmPasswordRef, setConfirmPasswordRef] = useState(null)
  const [password, setPassword] = useState({
    name: 'password',
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: true
  })

  const [confirmPassword, setConfirmPassword] = useState({
    name: 'confirmPassword',
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: true
  })

  useEffect(() => {
    if (passwordRef) {
      passwordRef.current.focus()
    }
  }, [passwordRef])

  useEffect(() => {
    if (confirmPasswordRef) {
      confirmPasswordRef.current.focus()
    }
  }, [confirmPasswordRef])

  const handlePasswordChange = (event) => {
    if (event) {
      const { value } = event.target
      setPassword({ ...password, value: value })
    }
  }

  const handleConfirmPasswordChange = (event) => {
    if (event) {
      const { value } = event.target
      setConfirmPassword({ ...confirmPassword, value: value })
    }
  }

  const handleCancel = () => {
    if (currentState.selectedOrgId && currentState.selectedOrgId > 0) {
      setCurrentStep('workplace-invitation')
    } else {
      setCurrentStep('email')
    }
  }

  const validate = () => {
    setPassword({ ...password, hasError: false })
    setConfirmPassword({ ...confirmPassword, hasError: false })
    if (isEmpty(password.value)) {
      setPassword({ ...password, hasError: true, errorMessage: t('signup.password_module.error_msg_1') })
      return false
    }
    if (!isPasswordComplex(password.value)) {
      setPassword({ ...password, hasError: true, errorMessage: t('signup.password_module.error_msg_2') })
      return false
    }
    if (isEmpty(confirmPassword.value)) {
      setConfirmPassword({ ...confirmPassword, hasError: true, errorMessage: t('signup.password_module.error_msg_1') })
      return false
    }
    if (password.value !== confirmPassword.value) {
      setConfirmPassword({ ...confirmPassword, hasError: true, errorMessage: t('signup.password_module.error_msg_3') })
      return false
    }

    return true
  }

  const handleNext = (e) => {
    e.preventDefault()
    const isValid = validate()
    if (isValid) {
      if (currentState && setCurrentState) {
        setCurrentState({ ...currentState, password: password.value })
        if (workplaceInvitations && workplaceInvitations.length > 0) {
          setCurrentStep('workplace-invitation')
        } else {
          const { email, selectedOrgId } = currentState
          if (email && password.value) {
            dispatch(loginActions.login(email, password.value, selectedOrgId, '', false))
          }
        }
      }
    }
  }

  return (
    <div className={styles.passwordContainer}>
      <h1 className={parentStyles.title}>{t('login.password.title', { name: '' })}</h1>
      <h2 className={parentStyles.subTitle}>{t('login.password.subTitle')}</h2>
      <form className={styles.form} onSubmit={handleNext}>
        <ErrorMessage text={error} className={styles.error} />
        <PasswordTextBox
          label={t('signup.password_module.password_pl')}
          value={password.value}
          placeholder={t('signup.password_module.password_pl')}
          handleChange={handlePasswordChange}
          className={styles.passwordWrapper}
          direction='column'
          isRequired={true}
          errorMessage={password.errorMessage}
          setRef={setPasswordRef}
        />
        <div className={styles.subtext}>{t('global.passwordSuggestion')}</div>
        <PasswordTextBox
          label={t('signup.password_module.retype_pl')}
          value={confirmPassword.value}
          placeholder={t('signup.password_module.retype_pl')}
          handleChange={handleConfirmPasswordChange}
          className={styles.passwordWrapper}
          direction='column'
          isRequired={true}
          errorMessage={confirmPassword.errorMessage}
        />

        <div className={`${parentStyles.buttons} ${styles.buttons}`}>
          <Button text={t('global.back')} style='secondary' handleClick={handleCancel} />
          <Button text={t('global.confirm')} type='submit' customStyle={styles.signin} />
          {loading && <Spinner customCss={styles.spinner} />}
        </div>
      </form>
      {loading && <Spinner />}
    </div>
  )
}

export default ConfirmPassword
